import { render, staticRenderFns } from "./PTOAttachEmploymentsModal.vue?vue&type=template&id=3c27d401&scoped=true&"
import script from "./PTOAttachEmploymentsModal.vue?vue&type=script&lang=ts&"
export * from "./PTOAttachEmploymentsModal.vue?vue&type=script&lang=ts&"
import style0 from "./PTOAttachEmploymentsModal.vue?vue&type=style&index=0&id=3c27d401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27d401",
  null
  
)

export default component.exports